const en = {
  nav: {
    dashboard: "Dashboard",
    cari: "Customer Mgmt",
    stok: "Inventory",
    sepet: "Cart",
    stokHareketleri: "Stock Movements",
    siparisler: "Orders",
    faturalar: "Invoices",
    kasaBanka: "Cash / Bank",
    cekSenet: "Bills / Notes",
    raporlar: "Reports",
    excelImport: "Excel Import",
    marjKontrolu: "Margin Check",
    kullanicilar: "Users",
    ayarlar: "Settings",
    logout: "Logout",
  },
  common: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    search: "Search",
    filter: "Filter",
    all: "All",
    loading: "Loading...",
    noData: "No records found",
    confirm_delete: "Are you sure you want to delete?",
    yes: "Yes",
    no: "No",
    total: "Total",
    page: "Page",
    new: "New",
    export_excel: "Export Excel",
    saving: "Saving...",
    close: "Close",
  },
  labels: {
    code: "Code",
    name: "Name",
    date: "Date",
    amount: "Amount",
    status: "Status",
    description: "Description",
    document_no: "Document No",
    debit: "Debit",
    credit: "Credit",
    balance: "Balance",
    due_date: "Due Date",
    bank: "Bank",
    type: "Type",
    account: "Account",
    currency: "Currency",
    price: "Price",
    quantity: "Qty",
    unit: "Unit",
    brand: "Brand",
    note: "Note",
  },
  status: {
    beklemede: "Pending",
    onaylandi: "Approved",
    hazirlaniyor: "Approved",
    sevkiyat: "Approved",
    tamamlandi: "Completed",
    iptal: "Cancelled",
    tahsil_edildi: "Collected",
    iade: "Returned",
    ciro_edildi: "Endorsed",
    aktif: "Active",
    pasif: "Inactive",
  },
  reports: {
    title: "Reports",
    cari_bakiye: "Customer Balances",
    stok_degeri: "Stock Value",
    siparis: "Order Report",
    yaslandirma: "Aging Report",
    kasa_banka: "Cash / Bank",
    date_range: "Date Range",
    start_date: "Start Date",
    end_date: "End Date",
    bucket_30: "0-30 days",
    bucket_60: "31-60 days",
    bucket_90: "61-90 days",
    bucket_90p: "90+ days",
  },
  kasa: {
    title: "Cash / Bank",
    account_name: "Account Name",
    account_type: "Account Type",
    kasa: "Cash",
    banka: "Bank",
    new: "New Entry",
    total_kasa: "Total Cash",
    total_banka: "Total Bank",
    grand_total: "Grand Total",
  },
  cek: {
    title: "Bills / Notes",
    alacakli_cek: "Receivable Check",
    borclu_cek: "Payable Check",
    alacakli_senet: "Receivable Note",
    borclu_senet: "Payable Note",
    new: "New Bill/Note",
    portfolio: "Portfolio",
  },
};

export default en;
